import { html } from 'lit';

export const iconCheckmark = html`
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12.3516 0.648438C12.707 0.976562 12.707 1.55078 12.3516 1.87891L5.35156 8.87891C5.02344 9.23438 4.44922 9.23438 4.12109 8.87891L0.621094 5.37891C0.265625 5.05078 0.265625 4.47656 0.621094 4.14844C0.949219 3.79297 1.52344 3.79297 1.85156 4.14844L4.72266 7.01953L11.1211 0.648438C11.4492 0.292969 12.0234 0.292969 12.3516 0.648438Z"
      fill="currentColor"
    />
  </svg>
`;
